import { rm } from "@/lib/api";
import { AdminHeader } from "@/components/platform/AdminHeader";
import { RecordList, Badge, day } from "@/components/platform/orders/RecordList";
import { InvoiceButton } from "@/components/InvoiceButton";

const C = "px-3 py-2.5";
const KIND = { order: "Customer order", ad: "Ad campaign", topup: "Ad wallet top-up" };
const COPY = {
  vendor: ["Vendor purchases", "Ads and Ad Wallet top-ups bought by vendors."],
  "": ["All payments", "Every payment received through the platform, from players and vendors."],
};

export function Payments({ who = "" }) {
  const [title, sub] = COPY[who];
  return (
    <div data-testid={`payments-${who || "all"}`}>
      <AdminHeader title={title} sub={sub} />
      <RecordList key={who} url="/asv/admin/payments" params={{ who }} prefix="payments" statuses={["paid", "partially_refunded", "refunded", "pending"]}
        head={[["Payment"], ["Payer", "hidden md:table-cell"], ["Date", "hidden sm:table-cell"], ["Method", "hidden lg:table-cell"], ["Amount", "text-right"], ["Status"], ["Invoice", "hidden sm:table-cell"]]}
        row={(p) => (
          <tr key={p.id} className="border-t border-slate-800" data-testid={`payment-row-${p.id}`}>
            <td className={`${C} max-w-[150px] sm:max-w-[220px]`}><p className="truncate font-semibold text-white" title={p.description}>{p.description || KIND[p.kind]}</p>
              <p className="text-xs text-slate-500">{KIND[p.kind] || p.kind}{p.mode === "mock" && <span className="ml-1 text-amber-300">· test</span>}</p></td>
            <td className={`${C} hidden md:table-cell`}><p className="text-slate-200">{p.name || p.vendor_slug}</p><p className="text-xs text-slate-500">{p.email}</p></td>
            <td className={`${C} hidden whitespace-nowrap text-slate-400 sm:table-cell`}>{day(p.paid_at || p.created_at)}</td>
            <td className={`${C} hidden uppercase text-slate-400 lg:table-cell`}>{p.method || "-"}</td>
            <td className={`${C} whitespace-nowrap text-right text-white`}>{rm(p.amount_sen)}{!!p.refunded_sen && <p className="text-xs text-rose-300">-{rm(p.refunded_sen)}</p>}</td>
            <td className="py-2.5 pl-1 pr-2"><Badge s={p.status} /></td>
            <td className={`${C} hidden sm:table-cell`}>{["paid", "partially_refunded", "refunded"].includes(p.status) && <InvoiceButton path={`/asv/admin/payments/${p.id}/invoice`} testid={`payment-invoice-${p.id}`} label="PDF" className="rounded-full border border-slate-700 px-2.5 py-1 text-xs text-slate-200 hover:bg-slate-800" />}</td>
          </tr>)} />
    </div>
  );
}
